(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article"]) return;
  try {
    
  (function () {
    // ---------- Routine builder: add all to cart ----------
    const routine = document.querySelector('[data-routine]');
    if (routine) {
      const addBtn = routine.querySelector('[data-routine-add]');
      const items = routine.querySelectorAll('[data-routine-variant]');

      if (addBtn && items.length > 0) {
        addBtn.addEventListener('click', async function () {
          const originalLabel = addBtn.textContent;
          addBtn.disabled = true;
          addBtn.textContent = 'Adding…';

          const payload = Array.from(items).map(function (el) {
            const item = { id: parseInt(el.dataset.routineVariant, 10), quantity: 1 };
            const plan = parseInt(el.dataset.routinePlan, 10);
            if (plan) item.selling_plan = plan;
            return item;
          }).filter(function (it) { return it.id; });

          try {
            if (window.YuveCart && typeof window.YuveCart.addItems === 'function') {
              await window.YuveCart.addItems(payload);
            } else {
              const res = await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({ items: payload }),
              });
              if (!res.ok) throw new Error('Could not add routine to cart.');
              window.location.href = '/cart';
            }
          } catch (err) {
            alert(err.message || 'Could not add routine to cart.');
          } finally {
            addBtn.disabled = false;
            addBtn.textContent = originalLabel;
          }
        });
      }
    }

    // ---------- Mid-article template injections (email capture + shop-the-solution) ----------
    // Strategy: insert each module BEFORE an h2/h3 so it sits at a natural section
    // break. Module belongs to the content above; following heading starts a fresh section.
    const articleBody = document.querySelector('[data-article-body]');
    if (articleBody) {
      const headings = Array.from(articleBody.querySelectorAll(':scope > h2, :scope > h4'));
      const captureTpl = document.querySelector('[data-article-capture-template]');
      const pitchTpl = document.querySelector('[data-article-pitch-template]');

      function getPct(tpl, fallback) {
        const raw = parseInt(tpl.getAttribute('data-position-pct'), 10);
        return (raw > 0 && raw < 100) ? raw : fallback;
      }

      // Need at least 2 headings to place both modules without overlap; skip index 0
      // because inserting before the very first heading lands too close to article top.
      if (headings.length >= 2) {
        const maxIdx = headings.length - 1;

        function pickIdx(tpl, fallbackPct, minIdx) {
          if (!tpl) return -1;
          const pct = getPct(tpl, fallbackPct);
          const raw = Math.floor(headings.length * pct / 100);
          return Math.max(minIdx, Math.min(raw, maxIdx));
        }

        const captureIdx = pickIdx(captureTpl, 33, 1);
        const pitchIdx = pickIdx(pitchTpl, 67, captureIdx >= 0 ? captureIdx + 1 : 1);

        if (pitchIdx >= 0 && pitchIdx <= maxIdx) {
          const h = headings[pitchIdx];
          h.parentNode.insertBefore(pitchTpl.content.cloneNode(true), h);
        }
        if (captureIdx >= 0 && captureIdx <= maxIdx && captureIdx !== pitchIdx) {
          const h = headings[captureIdx];
          h.parentNode.insertBefore(captureTpl.content.cloneNode(true), h);
        }
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["best-sellers"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const rail = document.querySelector('.js-rail');
    const prev = document.querySelector('.js-rail-prev');
    const next = document.querySelector('.js-rail-next');
    if (!rail || !prev || !next) return;

    function scrollAmount() {
      const firstCard = rail.querySelector('.product-card');
      if (!firstCard) return 300;
      const cardWidth = firstCard.getBoundingClientRect().width;
      const gap = parseFloat(getComputedStyle(rail).columnGap || getComputedStyle(rail).gap) || 20;
      return cardWidth + gap;
    }

    function updateArrows() {
      const maxScroll = rail.scrollWidth - rail.clientWidth;
      prev.disabled = rail.scrollLeft <= 2;
      next.disabled = rail.scrollLeft >= maxScroll - 2;
    }

    prev.addEventListener('click', function () {
      rail.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      rail.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
    });
    rail.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    updateArrows();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["build-your-bundle"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('.byob');
    if (!root) return;

    const discountPct = parseInt(root.dataset.discountPct, 10) || 20;
    const subscribePct = parseInt(root.dataset.subscribePct, 10) || 15;
    const minItems = parseInt(root.dataset.minItems, 10) || 3;
    const multiplier = (100 - discountPct) / 100;

    const cards = root.querySelectorAll('[data-byob-card]');
    const summary = root.querySelector('[data-byob-summary]');
    const countEl = root.querySelector('[data-byob-count]');
    const progressEl = root.querySelector('[data-byob-progress]');
    const statusEl = root.querySelector('[data-byob-status]');
    const itemsList = root.querySelector('[data-byob-items]');
    const emptyState = root.querySelector('[data-byob-empty]');
    const optionsEl = root.querySelector('[data-byob-options]');
    const priceEl = root.querySelector('[data-byob-price]');
    const subtotalEl = root.querySelector('[data-byob-subtotal]');
    const totalEl = root.querySelector('[data-byob-total]');
    const savingsEl = root.querySelector('[data-byob-savings]');
    const ctaBtn = root.querySelector('[data-byob-add]');
    const ctaLabel = root.querySelector('[data-byob-cta-label]');
    const errorEl = root.querySelector('[data-byob-error]');
    const radios = root.querySelectorAll('[name="byob-purchase"]');
    const optPriceEls = {
      subscribe: root.querySelector('[data-byob-option-price="subscribe"]'),
      onetime: root.querySelector('[data-byob-option-price="onetime"]'),
    };

    // Map of productId -> product data object
    const selected = new Map();

    function formatMoney(cents) {
      const dollars = (cents / 100).toFixed(2);
      return '$' + dollars.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    function currentMode() {
      const checked = root.querySelector('[name="byob-purchase"]:checked');
      return checked ? checked.value : 'subscribe';
    }

    function getCardData(card) {
      return {
        productId: card.dataset.productId,
        variantId: parseInt(card.dataset.variantId, 10),
        sellingPlanId: card.dataset.sellingPlanId ? parseInt(card.dataset.sellingPlanId, 10) : null,
        price: parseInt(card.dataset.price, 10),
        subscribePrice: parseInt(card.dataset.subscribePrice, 10),
        handle: card.dataset.handle,
        title: card.dataset.title,
        image: card.dataset.image,
        card: card,
      };
    }

    function render() {
      const items = Array.from(selected.values());
      const count = items.length;
      const mode = currentMode();
      const unlocked = count >= minItems;

      // Count + progress
      countEl.textContent = count + ' / ' + minItems;
      const pct = Math.min(100, (count / minItems) * 100);
      progressEl.style.width = pct + '%';
      summary.dataset.unlocked = unlocked ? 'true' : 'false';

      // Status copy
      if (count === 0) {
        statusEl.textContent = 'Pick ' + minItems + ' to unlock ' + discountPct + '% off.';
      } else if (!unlocked) {
        const remaining = minItems - count;
        statusEl.textContent = 'Add ' + remaining + ' more to unlock ' + discountPct + '% off.';
      } else {
        statusEl.textContent = discountPct + '% bundle discount unlocked.';
      }

      // Items list
      itemsList.innerHTML = '';
      items.forEach(function (item) {
        const li = document.createElement('li');
        li.className = 'byob__item';
        const displayPrice = mode === 'subscribe' ? item.subscribePrice : item.price;
        li.innerHTML =
          '<div class="byob__item-media">' +
            (item.image ? '<img src="' + item.image + '" alt="" loading="lazy">' : '') +
          '</div>' +
          '<div class="byob__item-info">' +
            '<span class="byob__item-title">' + item.title + '</span>' +
            '<span class="byob__item-price">' + formatMoney(displayPrice) + '</span>' +
          '</div>' +
          '<button type="button" class="byob__item-remove" aria-label="Remove ' + item.title + '">' +
            '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>' +
          '</button>';
        li.querySelector('.byob__item-remove').addEventListener('click', function () {
          toggleSelect(item.card, false);
        });
        itemsList.appendChild(li);
      });

      // Empty state visibility
      emptyState.hidden = count > 0;

      // Options + price visibility
      optionsEl.hidden = count === 0;
      priceEl.hidden = count === 0;

      // Price math
      const subtotalOnetime = items.reduce(function (sum, it) { return sum + it.price; }, 0);
      const subtotalSubscribe = items.reduce(function (sum, it) { return sum + it.subscribePrice; }, 0);
      const bundleOnetime = Math.round(subtotalOnetime * multiplier);
      const bundleSubscribe = Math.round(subtotalSubscribe * multiplier);

      optPriceEls.subscribe.textContent = formatMoney(unlocked ? bundleSubscribe : subtotalSubscribe);
      optPriceEls.onetime.textContent = formatMoney(unlocked ? bundleOnetime : subtotalOnetime);

      const displaySubtotal = mode === 'subscribe' ? subtotalSubscribe : subtotalOnetime;
      const displayTotal = unlocked
        ? (mode === 'subscribe' ? bundleSubscribe : bundleOnetime)
        : displaySubtotal;
      subtotalEl.textContent = formatMoney(displaySubtotal);
      totalEl.textContent = formatMoney(displayTotal);

      // Savings copy
      if (unlocked) {
        const regularTotal = subtotalOnetime;
        const savings = regularTotal - displayTotal;
        if (mode === 'subscribe') {
          savingsEl.textContent = 'You save ' + formatMoney(savings) + ' (' + discountPct + '% bundle + ' + subscribePct + '% subscribe) - applied at checkout.';
        } else {
          savingsEl.textContent = 'You save ' + formatMoney(savings) + ' (' + discountPct + '% off) - applied at checkout.';
        }
      } else {
        savingsEl.textContent = '';
      }

      // CTA
      if (unlocked) {
        ctaBtn.disabled = false;
        ctaLabel.textContent = 'Add bundle to cart · ' + formatMoney(displayTotal);
      } else {
        ctaBtn.disabled = true;
        const remaining = minItems - count;
        ctaLabel.textContent = count === 0
          ? 'Pick ' + minItems + ' to continue'
          : 'Pick ' + remaining + ' more';
      }
    }

    function toggleSelect(card, forceState) {
      const data = getCardData(card);
      const isSelected = selected.has(data.productId);
      const shouldSelect = typeof forceState === 'boolean' ? forceState : !isSelected;

      if (shouldSelect && !isSelected) {
        selected.set(data.productId, data);
        card.classList.add('is-selected');
        card.querySelector('[data-byob-toggle]').setAttribute('aria-pressed', 'true');
      } else if (!shouldSelect && isSelected) {
        selected.delete(data.productId);
        card.classList.remove('is-selected');
        card.querySelector('[data-byob-toggle]').setAttribute('aria-pressed', 'false');
      }
      render();
    }

    cards.forEach(function (card) {
      const toggleBtn = card.querySelector('[data-byob-toggle]');
      if (toggleBtn) {
        toggleBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          toggleSelect(card);
        });
      }
      // Clicking anywhere else on the card also toggles (except inside the button, handled above)
      card.addEventListener('click', function (e) {
        if (e.target.closest('[data-byob-toggle]')) return;
        toggleSelect(card);
      });
    });

    radios.forEach(function (r) { r.addEventListener('change', render); });

    function setError(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg;
      errorEl.hidden = !msg;
    }

    ctaBtn.addEventListener('click', async function () {
      if (ctaBtn.disabled) return;
      setError('');

      const mode = currentMode();
      const items = Array.from(selected.values()).map(function (it) {
        const item = { id: it.variantId, quantity: 1 };
        if (mode === 'subscribe' && it.sellingPlanId) {
          item.selling_plan = it.sellingPlanId;
        }
        return item;
      });

      ctaBtn.disabled = true;
      ctaBtn.classList.add('is-loading');

      try {
        if (window.YuveCart && typeof window.YuveCart.addItems === 'function') {
          await window.YuveCart.addItems(items);
        } else {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: items }),
          });
          if (!res.ok) {
            const data = await res.json().catch(function () { return {}; });
            throw new Error(data.description || data.message || 'Could not add bundle to cart.');
          }
          window.location.href = '/cart';
        }
      } catch (err) {
        setError(err.message || 'Could not add bundle to cart. Please try again.');
      } finally {
        ctaBtn.disabled = false;
        ctaBtn.classList.remove('is-loading');
        render();
      }
    });

    render();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bundle-detail"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const section = document.querySelector('.bundle');
    if (!section) return;

    const addBtn = section.querySelector('[data-bundle-add]');
    const errorEl = section.querySelector('.js-bundle-error');
    const priceBlock = section.querySelector('.bundle__price');
    const radios = section.querySelectorAll('[name="bundle-purchase"]');

    const variantIds = (section.getAttribute('data-bundle-variants') || '')
      .split(',').map(s => parseInt(s.trim(), 10)).filter(Boolean);
    const sellingPlanIds = (section.getAttribute('data-selling-plans') || '')
      .split(',').map(s => parseInt(s.trim(), 10) || null);

    const defaultMode = section.getAttribute('data-default-mode') || 'onetime';

    // Force the default purchase mode on initial load (overrides browser form restore)
    const defaultRadio = section.querySelector('[name="bundle-purchase"][value="' + defaultMode + '"]');
    if (defaultRadio) defaultRadio.checked = true;

    function currentMode() {
      const checked = section.querySelector('[name="bundle-purchase"]:checked');
      return checked ? checked.value : defaultMode;
    }

    function applyMode(mode) {
      if (priceBlock) priceBlock.setAttribute('data-mode', mode);
    }

    radios.forEach(r => r.addEventListener('change', () => applyMode(currentMode())));
    applyMode(currentMode());

    function setError(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg;
      errorEl.hidden = !msg;
    }

    if (addBtn && variantIds.length > 0) {
      addBtn.addEventListener('click', async function () {
        setError('');
        addBtn.disabled = true;
        addBtn.classList.add('is-loading');

        const mode = currentMode();
        const items = variantIds.map((id, i) => {
          const item = { id: id, quantity: 1 };
          if (mode === 'subscribe' && sellingPlanIds[i]) {
            item.selling_plan = sellingPlanIds[i];
          }
          return item;
        });

        try {
          if (window.YuveCart && typeof window.YuveCart.addItems === 'function') {
            await window.YuveCart.addItems(items);
          } else {
            // Fallback: no drawer, just redirect to cart
            const res = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ items }),
            });
            if (!res.ok) {
              const data = await res.json().catch(() => ({}));
              throw new Error(data.description || data.message || 'Could not add bundle to cart.');
            }
            window.location.href = '/cart';
          }
        } catch (err) {
          setError(err.message || 'Could not add bundle to cart. Please try again.');
        } finally {
          addBtn.disabled = false;
          addBtn.classList.remove('is-loading');
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    const section = document.querySelector('.cart-page');
    if (!section) return;

    const threshold = parseInt(section.getAttribute('data-threshold-cents'), 10) || 0;
    const bundleMin = parseInt(section.getAttribute('data-bundle-min-items'), 10) || 0;
    const bundleDiscountPct = parseInt(section.getAttribute('data-bundle-discount-pct'), 10) || 0;

    // Sum the per-line subtotal (after subscribe discounts, before bundle
    // discount) from the data-* attributes Liquid emits on each line.
    // data-unit-price holds the pre-bundle, subscribe-aware unit price.
    function computeSubtotalPreBundle() {
      let s = 0;
      section.querySelectorAll('[data-cart-line]').forEach(l => {
        const u = parseInt(l.getAttribute('data-unit-price'), 10) || 0;
        const q = parseInt(l.getAttribute('data-quantity'), 10) || 0;
        s += u * q;
      });
      return s;
    }

    function computeLineSavings() {
      let s = 0;
      section.querySelectorAll('[data-cart-line]').forEach(l => {
        const unit = parseInt(l.getAttribute('data-unit-price'), 10) || 0;
        const compare = parseInt(l.getAttribute('data-unit-compare'), 10) || unit;
        const q = parseInt(l.getAttribute('data-quantity'), 10) || 0;
        if (compare > unit) s += (compare - unit) * q;
      });
      return s;
    }

    function bundleDiscountAmount(subtotalPre, itemCount) {
      if (bundleMin <= 0 || bundleDiscountPct <= 0) return 0;
      if (itemCount < bundleMin) return 0;
      return Math.round(subtotalPre * bundleDiscountPct / 100);
    }

    const cartState = {
      itemCount: parseInt(section.getAttribute('data-item-count'), 10) || 0,
      subtotalPreBundle: 0,
      totalPrice: 0,
    };
    cartState.subtotalPreBundle = computeSubtotalPreBundle();
    cartState.totalPrice = Math.max(0,
      cartState.subtotalPreBundle - bundleDiscountAmount(cartState.subtotalPreBundle, cartState.itemCount));

    // DOM refs (may be absent in empty cart - guarded below)
    const subtitle = section.querySelector('.cart-page__subtitle');
    const subtotalRow = section.querySelector('.cart-page__total-row--subtotal span:last-child');
    const discountRow = section.querySelector('.cart-page__total-row--discount');
    const progressCopy = section.querySelector('.cart-page__progress-copy');
    const progressFill = section.querySelector('.cart-page__fill');
    const progressTier = section.querySelector('.cart-page__tier');
    const progressLabel = section.querySelector('.cart-page__track-label');
    const bundleDotsWrap = section.querySelector('.cart-page__bundle-dots');
    const bundleNote = section.querySelector('.cart-page__bundle-note');
    const bundleNoteCopy = bundleNote ? bundleNote.querySelector(':scope > span:not(.cart-page__bundle-dots)') : null;

    function formatMoney(cents) {
      return '$' + ((cents || 0) / 100).toFixed(2);
    }

    // ---------- Optimistic DOM updaters ----------

    function applyOptimisticQty(line, newQty) {
      line.setAttribute('data-quantity', String(newQty));
      applyState();
    }

    // Single source of truth - recompute item count, subtotal, bundle
    // discount, allocate per-line displays, and refresh every relevant DOM
    // hook from the data-* attributes Liquid emitted on each line.
    function applyState() {
      const lines = Array.from(section.querySelectorAll('[data-cart-line]'));
      let itemCount = 0;
      let subtotalPre = 0;
      lines.forEach(l => {
        const u = parseInt(l.getAttribute('data-unit-price'), 10) || 0;
        const q = parseInt(l.getAttribute('data-quantity'), 10) || 0;
        itemCount += q;
        subtotalPre += u * q;
      });

      const bundleActive = bundleMin > 0 && bundleDiscountPct > 0 && itemCount >= bundleMin;
      const bundleFactor = bundleActive ? (100 - bundleDiscountPct) / 100 : 1;

      let displayedTotal = 0;
      let originalTotal = 0;

      lines.forEach(l => {
        const u = parseInt(l.getAttribute('data-unit-price'), 10) || 0;
        const c = parseInt(l.getAttribute('data-unit-compare'), 10) || u;
        const q = parseInt(l.getAttribute('data-quantity'), 10) || 0;
        const linePre = u * q;
        const display = bundleActive ? Math.round(linePre * bundleFactor) : linePre;
        const original = c * q;
        const savings = Math.max(0, original - display);
        displayedTotal += display;
        originalTotal += original;

        const qtyEl = l.querySelector('[data-qty-value]');
        if (qtyEl) qtyEl.textContent = q;

        const priceEl = l.querySelector('.cart-line__price');
        if (priceEl) priceEl.textContent = formatMoney(display);

        const wasEl = l.querySelector('.cart-line__price-was');
        if (wasEl) {
          if (savings > 0) {
            wasEl.textContent = formatMoney(original);
            wasEl.hidden = false;
          } else {
            wasEl.hidden = true;
          }
        }

        const savEl = l.querySelector('.cart-line__savings');
        if (savEl) {
          if (savings > 0) {
            savEl.textContent = formatMoney(savings) + ' savings';
            savEl.hidden = false;
          } else {
            savEl.hidden = true;
          }
        }
      });

      cartState.itemCount = itemCount;
      cartState.subtotalPreBundle = subtotalPre;
      cartState.totalPrice = displayedTotal;

      renderSummary(originalTotal - displayedTotal);
    }

    function renderSummary(precomputedSavings) {
      if (subtitle) subtitle.textContent = cartState.itemCount === 1 ? '1 item' : cartState.itemCount + ' items';
      if (subtotalRow) subtotalRow.textContent = formatMoney(cartState.totalPrice);

      // Shipping bar
      if (threshold > 0 && progressFill) {
        const pct = Math.min(100, Math.round((cartState.totalPrice / threshold) * 100));
        progressFill.style.width = pct + '%';
        const reached = cartState.totalPrice >= threshold;
        if (progressTier) progressTier.classList.toggle('is-reached', reached);
        if (progressLabel) progressLabel.classList.toggle('is-reached', reached);
        if (progressCopy) {
          if (reached) {
            progressCopy.classList.add('is-unlocked');
            progressCopy.textContent = 'Free shipping unlocked ✓';
          } else {
            progressCopy.classList.remove('is-unlocked');
            const remaining = threshold - cartState.totalPrice;
            progressCopy.innerHTML = 'Add <strong>' + formatMoney(remaining) + '</strong> to unlock free shipping.';
          }
        }
      }

      // Bundle dots + note
      if (bundleMin > 0 && bundleDotsWrap) {
        const filled = Math.min(cartState.itemCount, bundleMin);
        let html = '';
        for (let i = 0; i < bundleMin; i++) {
          html += '<span class="cart-page__bundle-dot' + (i < filled ? ' is-filled' : '') + '"></span>';
        }
        bundleDotsWrap.innerHTML = html;
      }
      if (bundleNoteCopy) {
        if (cartState.itemCount >= bundleMin) {
          bundleNoteCopy.className = 'is-unlocked';
          bundleNoteCopy.textContent = bundleDiscountPct + '% off your order unlocked ✓';
        } else {
          bundleNoteCopy.className = '';
          const remaining = bundleMin - cartState.itemCount;
          const noun = remaining === 1 ? 'item' : 'items';
          bundleNoteCopy.innerHTML = 'Add <strong>' + remaining + ' more ' + noun + '</strong> to save ' + bundleDiscountPct + '%.';
        }
      }

      // Discount row - combined subscribe + bundle savings.
      if (discountRow) {
        const total = precomputedSavings != null
          ? precomputedSavings
          : computeLineSavings() + bundleDiscountAmount(cartState.subtotalPreBundle, cartState.itemCount);
        if (total > 0) {
          discountRow.hidden = false;
          const valueEl = discountRow.querySelector('span:last-child');
          if (valueEl) valueEl.textContent = '−' + formatMoney(total);
        } else {
          discountRow.hidden = true;
        }
      }
    }

    // ---------- Debounced network ----------

    const pendingChanges = new Map(); // key → { quantity, timer }
    const QTY_DEBOUNCE_MS = 260;

    function setQty(line, newQty) {
      const key = line.getAttribute('data-key');
      const safeQty = Math.max(0, newQty | 0);

      // Remove → full reload (indices shift, discount row may appear/disappear)
      if (safeQty === 0) {
        const existing = pendingChanges.get(key);
        if (existing && existing.timer) clearTimeout(existing.timer);
        pendingChanges.delete(key);
        line.classList.add('is-updating');
        flushRemove(line);
        return;
      }

      applyOptimisticQty(line, safeQty);

      const existing = pendingChanges.get(key);
      if (existing && existing.timer) clearTimeout(existing.timer);
      const entry = { quantity: safeQty, timer: null };
      entry.timer = setTimeout(() => flushQtyChange(line, key), QTY_DEBOUNCE_MS);
      pendingChanges.set(key, entry);
    }

    async function flushQtyChange(line, key) {
      const entry = pendingChanges.get(key);
      if (!entry) return;
      pendingChanges.delete(key);

      const lineIndex = parseInt(line.getAttribute('data-line'), 10);
      const payload = { line: lineIndex, quantity: entry.quantity };
      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(payload),
        });
        if (!res.ok) throw new Error('cart change failed');
        const cart = await res.json();
        // If more debounced clicks are queued, skip reconcile - they'll land next.
        if (pendingChanges.size > 0) return;
        reconcile(cart);
      } catch (err) {
        // Fall back to page reload on any error so the user sees a correct state
        window.location.reload();
      }
    }

    async function flushRemove(line) {
      const lineIndex = parseInt(line.getAttribute('data-line'), 10);
      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ line: lineIndex, quantity: 0 }),
        });
        if (!res.ok) throw new Error('remove failed');
        window.location.reload();
      } catch (err) {
        line.classList.remove('is-updating');
      }
    }

    function unitPreBundle(item) {
      if (item.selling_plan_allocation) {
        return item.selling_plan_allocation.price || item.original_price || 0;
      }
      return item.original_price || 0;
    }

    // Retail "compare at" per unit. See cart-drawer.liquid for the rationale.
    function compareAtUnit(item) {
      if (item.selling_plan_allocation && item.selling_plan_allocation.compare_at_price) {
        return item.selling_plan_allocation.compare_at_price;
      }
      return item.original_price || 0;
    }

    // Reconcile data-* attrs to server truth, then let applyState rebuild
    // every display from a single basis.
    function reconcile(cart) {
      const lines = Array.from(section.querySelectorAll('[data-cart-line]'));
      (cart.items || []).forEach((item, idx) => {
        const line = lines[idx];
        if (!line) return;
        const u = unitPreBundle(item);
        line.setAttribute('data-quantity', String(item.quantity || 0));
        line.setAttribute('data-unit-price', String(u));
        line.setAttribute('data-unit-compare', String(compareAtUnit(item) || u));
      });
      applyState();
    }

    // ---------- Event wiring ----------

    section.querySelectorAll('[data-cart-line]').forEach(line => {
      const qtyValue = line.querySelector('[data-qty-value]');
      const qtyInc = line.querySelector('[data-qty-increase]');
      const qtyDec = line.querySelector('[data-qty-decrease]');
      const removeBtn = line.querySelector('[data-remove]');
      const upgrade = line.querySelector('[data-upgrade]');

      if (qtyInc) qtyInc.addEventListener('click', () => {
        const q = parseInt(qtyValue.textContent, 10) || 1;
        setQty(line, q + 1);
      });
      if (qtyDec) qtyDec.addEventListener('click', () => {
        const q = parseInt(qtyValue.textContent, 10) || 1;
        setQty(line, q - 1);
      });
      if (removeBtn) removeBtn.addEventListener('click', () => setQty(line, 0));

      // Upgrade (subscribe & save) - optimistic price drop, then reload
      // for the structural swap (upgrade button → plan badge).
      if (upgrade) upgrade.addEventListener('click', async () => {
        const planId = parseInt(upgrade.getAttribute('data-plan-id'), 10);
        const pct = parseInt(upgrade.getAttribute('data-plan-pct'), 10) || 0;
        const q = parseInt(qtyValue.textContent, 10) || 1;
        const lineIndex = parseInt(line.getAttribute('data-line'), 10);
        upgrade.classList.add('is-loading');

        // Apply discount optimistically so the user sees the new price instantly
        if (pct > 0) {
          const unitPrice = parseInt(line.getAttribute('data-unit-price'), 10) || 0;
          const newUnit = Math.round(unitPrice * (100 - pct) / 100);
          line.setAttribute('data-unit-price', String(newUnit));
          // unit-compare keeps original (pre-subscribe) so the strike + savings
          // badge reflects the subscribe discount on this line going forward.
          applyState();
        }

        try {
          const res = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ line: lineIndex, quantity: q, selling_plan: planId }),
          });
          if (!res.ok) throw new Error('upgrade failed');
          window.location.reload();
        } catch (err) {
          upgrade.classList.remove('is-loading');
          window.location.reload();
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    const toggle = document.querySelector('.js-menu-toggle');
    const dialog = document.getElementById('mobile-menu');
    const closers = dialog ? dialog.querySelectorAll('.js-menu-close') : [];

    if (!toggle || !dialog) return;

    toggle.addEventListener('click', function () {
      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
        toggle.setAttribute('aria-expanded', 'true');
        if (document.activeElement && typeof document.activeElement.blur === 'function') {
          document.activeElement.blur();
        }
      }
    });

    closers.forEach(function (el) {
      el.addEventListener('click', function () {
        dialog.close();
      });
    });

    // Click on backdrop closes the dialog
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) {
        dialog.close();
      }
    });

    dialog.addEventListener('close', function () {
      toggle.setAttribute('aria-expanded', 'false');
    });

    // Close open desktop mega-menus when clicking outside
    document.addEventListener('click', function (event) {
      const openMenus = document.querySelectorAll('details.header__nav-item--has-menu[open]');
      openMenus.forEach(function (details) {
        if (!details.contains(event.target)) {
          details.open = false;
        }
      });
    });

    // ---------- Search overlay ----------
    const searchDialog = document.getElementById('search-overlay');
    if (!searchDialog) return;

    const openTriggers = document.querySelectorAll('.js-search-open');
    const searchCloseBtn = searchDialog.querySelector('.js-search-close');
    const backdrop = searchDialog.querySelector('.search-overlay__backdrop');
    const form = searchDialog.querySelector('[data-search-form]');
    const input = searchDialog.querySelector('[data-search-input]');
    const clearBtn = searchDialog.querySelector('[data-search-clear]');
    const resultsEl = searchDialog.querySelector('[data-search-results]');
    const statusEl = searchDialog.querySelector('[data-search-status]');

    let activeRequest = null;
    let debounceTimer = null;

    function openSearch() {
      if (dialog && dialog.open) dialog.close();
      if (typeof searchDialog.showModal === 'function') {
        searchDialog.showModal();
      } else {
        searchDialog.setAttribute('open', '');
      }
      openTriggers.forEach(function (btn) { btn.setAttribute('aria-expanded', 'true'); });
      setTimeout(function () { input && input.focus(); }, 60);
    }

    function closeSearch() {
      searchDialog.close();
    }

    openTriggers.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        openSearch();
      });
    });

    if (searchCloseBtn) searchCloseBtn.addEventListener('click', closeSearch);
    if (backdrop) backdrop.addEventListener('click', closeSearch);

    searchDialog.addEventListener('click', function (event) {
      if (event.target === searchDialog) closeSearch();
    });

    searchDialog.addEventListener('close', function () {
      openTriggers.forEach(function (btn) { btn.setAttribute('aria-expanded', 'false'); });
    });

    form && form.addEventListener('submit', function (e) { e.preventDefault(); });

    // Keyboard shortcut: "/" opens search (ignored when typing in input/textarea)
    document.addEventListener('keydown', function (e) {
      if (e.key === '/' && !e.metaKey && !e.ctrlKey && !e.altKey) {
        const tag = (e.target.tagName || '').toLowerCase();
        const isEditable = tag === 'input' || tag === 'textarea' || e.target.isContentEditable;
        if (isEditable) return;
        e.preventDefault();
        openSearch();
      }
      if ((e.key === 'k' || e.key === 'K') && (e.metaKey || e.ctrlKey)) {
        e.preventDefault();
        openSearch();
      }
    });

    function escapeHtml(s) {
      return String(s == null ? '' : s)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }

    function showStatus(html) {
      statusEl.innerHTML = html;
      statusEl.hidden = false;
      resultsEl.hidden = true;
      resultsEl.innerHTML = '';
    }

    function showResults(html) {
      resultsEl.innerHTML = html;
      resultsEl.hidden = false;
      statusEl.hidden = true;
    }

    function renderResults(data) {
      const products = (data.resources && data.resources.results && data.resources.results.products) || [];
      const collections = (data.resources && data.resources.results && data.resources.results.collections) || [];
      const articles = (data.resources && data.resources.results && data.resources.results.articles) || [];
      const pages = (data.resources && data.resources.results && data.resources.results.pages) || [];

      const total = products.length + collections.length + articles.length + pages.length;
      if (total === 0) {
        showStatus('<p class="search-overlay__empty">No results for that. Try a broader term like "energy" or "digestion."</p>');
        return;
      }

      let html = '';

      if (products.length) {
        html += '<div class="search-overlay__group"><h3 class="search-overlay__group-title">Products</h3><ul class="search-overlay__list search-overlay__product-list" role="list">';
        products.forEach(function (p) {
          const img = p.featured_image && p.featured_image.url
            ? '<img src="' + escapeHtml(p.featured_image.url) + '" alt="' + escapeHtml(p.featured_image.alt || p.title) + '" loading="lazy">'
            : '';
          const price = p.price ? '<span class="search-overlay__result-meta">' + escapeHtml(p.price) + '</span>' : '';
          html += '<li><a class="search-overlay__result" href="' + escapeHtml(p.url) + '">' +
                  '<span class="search-overlay__result-media">' + img + '</span>' +
                  '<span class="search-overlay__result-body">' +
                    '<span class="search-overlay__result-title">' + escapeHtml(p.title) + '</span>' +
                    price +
                  '</span>' +
                  '</a></li>';
        });
        html += '</ul></div>';
      }

      function plainGroup(label, items) {
        if (!items.length) return '';
        let h = '<div class="search-overlay__group"><h3 class="search-overlay__group-title">' + label + '</h3><ul class="search-overlay__list" role="list">';
        items.forEach(function (it) {
          h += '<li><a class="search-overlay__result-plain" href="' + escapeHtml(it.url) + '">' + escapeHtml(it.title) + '</a></li>';
        });
        h += '</ul></div>';
        return h;
      }

      html += plainGroup('Collections', collections);
      html += plainGroup('Articles', articles);
      html += plainGroup('Pages', pages);

      showResults(html);
    }

    async function runQuery(q) {
      if (activeRequest && activeRequest.abort) {
        try { activeRequest.abort(); } catch (e) {}
      }
      const controller = new AbortController();
      activeRequest = controller;

      showStatus('<div class="search-overlay__loading"><span class="search-overlay__loading-spinner" aria-hidden="true"></span> Searching…</div>');

      try {
        const params = new URLSearchParams({
          'q': q,
          'resources[type]': 'product,collection,article,page',
          'resources[limit]': '8',
          'resources[options][unavailable_products]': 'last',
        });
        const res = await fetch('/search/suggest.json?' + params.toString(), {
          signal: controller.signal,
          headers: { 'Accept': 'application/json' },
        });
        if (!res.ok) throw new Error('Search failed');
        const data = await res.json();
        renderResults(data);
      } catch (err) {
        if (err.name === 'AbortError') return;
        showStatus('<p class="search-overlay__empty">Something went wrong. Please try again.</p>');
      } finally {
        if (activeRequest === controller) activeRequest = null;
      }
    }

    function onInput() {
      const q = (input.value || '').trim();
      clearBtn.hidden = q.length === 0;
      clearTimeout(debounceTimer);

      if (q.length === 0) {
        showStatus('<p class="search-overlay__hint">Try "probiotic", "iron", or "immunity."</p>');
        return;
      }
      if (q.length < 2) {
        showStatus('<p class="search-overlay__hint">Keep typing…</p>');
        return;
      }

      debounceTimer = setTimeout(function () { runQuery(q); }, 160);
    }

    if (input) input.addEventListener('input', onInput);

    if (clearBtn) clearBtn.addEventListener('click', function () {
      input.value = '';
      input.focus();
      onInput();
    });

    input && input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeSearch();
    });

    // Hide-on-scroll-down, reveal-on-scroll-up sticky behavior.
    // Uses an accumulator so slow steady scrolling still triggers, while
    // tiny bidirectional jitter (trackpad inertia) doesn't.
    const headerEl = document.querySelector('.header');
    if (headerEl) {
      let lastY = window.scrollY;
      let ticking = false;
      let accum = 0;
      let lastDir = 0;
      const DELTA = 5;

      function updateHeader() {
        const currentY = window.scrollY;
        const diff = currentY - lastY;
        const dir = diff > 0 ? 1 : (diff < 0 ? -1 : 0);
        // Hide once the user has scrolled past the header's own height.
        const hideAfter = headerEl.offsetHeight;

        if (dir !== 0) {
          accum = (dir === lastDir) ? accum + Math.abs(diff) : Math.abs(diff);
          lastDir = dir;
        }

        if (currentY < hideAfter) {
          headerEl.classList.remove('is-hidden');
        } else if (dir === 1 && accum >= DELTA) {
          headerEl.classList.add('is-hidden');
          document.querySelectorAll('details.header__nav-item--has-menu[open]').forEach(function (d) {
            d.removeAttribute('open');
          });
        } else if (dir === -1 && accum >= DELTA) {
          headerEl.classList.remove('is-hidden');
        }

        lastY = currentY;
        ticking = false;
      }

      window.addEventListener('scroll', function () {
        if (!ticking) {
          window.requestAnimationFrame(updateHeader);
          ticking = true;
        }
      }, { passive: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    const section = document.querySelector('.product');
    if (!section) return;

    /* ---------- Gallery thumbnail + swipe switching ---------- */
    const galleryMain = section.querySelector('.product__gallery-main');
    const thumbs = section.querySelectorAll('[data-thumb-for]');
    const mediaItems = section.querySelectorAll('[data-media-id]');

    function setActive(id) {
      thumbs.forEach(function (t) {
        t.classList.toggle('is-active', t.getAttribute('data-thumb-for') === id);
      });
      mediaItems.forEach(function (m) {
        m.classList.toggle('is-active', m.getAttribute('data-media-id') === id);
      });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        const id = thumb.getAttribute('data-thumb-for');
        setActive(id);
        // On mobile, also scroll the swipe carousel to the selected media
        const isMobileCarousel = window.matchMedia('(max-width: 959px)').matches;
        if (isMobileCarousel && galleryMain) {
          const target = Array.from(mediaItems).find(function (m) {
            return m.getAttribute('data-media-id') === id;
          });
          if (target) {
            galleryMain.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
          }
        }
      });
    });

    /* On mobile, observe which media is centered in view and sync is-active */
    if (galleryMain && 'IntersectionObserver' in window) {
      const mobileMQ = window.matchMedia('(max-width: 959px)');
      let observer = null;

      function enableSwipeObserver() {
        if (observer) return;
        observer = new IntersectionObserver(function (entries) {
          let best = null;
          entries.forEach(function (entry) {
            if (!best || entry.intersectionRatio > best.intersectionRatio) {
              best = entry;
            }
          });
          if (best && best.isIntersecting && best.intersectionRatio > 0.5) {
            setActive(best.target.getAttribute('data-media-id'));
          }
        }, { root: galleryMain, threshold: [0.5, 0.75, 1] });
        mediaItems.forEach(function (m) { observer.observe(m); });
      }

      function disableSwipeObserver() {
        if (!observer) return;
        observer.disconnect();
        observer = null;
      }

      if (mobileMQ.matches) enableSwipeObserver();
      mobileMQ.addEventListener('change', function (e) {
        if (e.matches) enableSwipeObserver();
        else disableSwipeObserver();
      });
    }

    /* ---------- Purchase option toggle + variant switching ---------- */
    const purchaseOptions = section.querySelectorAll('[data-purchase-option]');
    const purchaseInputs = section.querySelectorAll('[data-purchase-input]');
    const sellingPlanEl = section.querySelector('[data-selling-plan]');
    const sellingPlanValue = sellingPlanEl ? sellingPlanEl.value : '';
    const stickyPrice = section.querySelector('[data-sticky-price]');
    const subPriceEl = section.querySelector('[data-subscribe-price]');
    const subCompareEl = section.querySelector('[data-subscribe-compare]');
    const oneTimePriceEl = section.querySelector('[data-onetime-price]');
    const savingsLine = section.querySelector('[data-savings-line]');
    const savingsEl = section.querySelector('[data-savings]');
    const variantIdInput = section.querySelector('[data-variant-id]');
    const atcBtn = section.querySelector('[data-atc]');
    const atcText = section.querySelector('[data-atc-text]');
    const stockLine = section.querySelector('[data-stock-line]');
    const oosLine = section.querySelector('[data-oos-line]');
    const optionFieldsets = section.querySelectorAll('.product__option');
    const optionInputs = section.querySelectorAll('[data-option-input]');

    let currentMode = 'subscribe';

    function formatMoney(cents) {
      if (cents == null || isNaN(cents)) return '';
      return '$' + (cents / 100).toFixed(2);
    }

    function readVariants() {
      const script = section.querySelector('[data-product-variants]');
      if (!script) return [];
      try {
        return JSON.parse(script.textContent.trim());
      } catch (e) {
        return [];
      }
    }

    const variants = readVariants();

    function currentOptions() {
      const opts = [];
      optionFieldsets.forEach(function (fs) {
        const checked = fs.querySelector('input[type="radio"]:checked');
        if (checked) opts.push(checked.value);
      });
      return opts;
    }

    function findVariant(opts) {
      return variants.find(function (v) {
        return v.options.length === opts.length &&
               v.options.every(function (val, i) { return val === opts[i]; });
      });
    }

    function updateVariant() {
      const opts = currentOptions();
      const v = findVariant(opts);
      if (!v) return;

      if (variantIdInput) variantIdInput.value = v.id;

      if (subPriceEl && v.sub_price != null) subPriceEl.textContent = formatMoney(v.sub_price);
      if (subCompareEl && v.one_time_price != null) subCompareEl.textContent = formatMoney(v.one_time_price);
      if (oneTimePriceEl && v.one_time_price != null) oneTimePriceEl.textContent = formatMoney(v.one_time_price);

      const savings = (v.one_time_price != null && v.sub_price != null) ? v.one_time_price - v.sub_price : 0;
      if (savingsEl) savingsEl.textContent = formatMoney(savings);
      if (savingsLine) {
        if (savings > 0) savingsLine.removeAttribute('hidden');
        else savingsLine.setAttribute('hidden', '');
      }

      const stickyBtnEl = section.querySelector('[data-sticky-btn]');
      const stickyBtnText = section.querySelector('[data-sticky-btn-text]');

      if (atcBtn && atcText) {
        if (v.available) {
          atcBtn.removeAttribute('disabled');
          atcText.textContent = 'Add to cart';
          if (stickyBtnEl) stickyBtnEl.removeAttribute('disabled');
          if (stickyBtnText) stickyBtnText.textContent = 'Add to cart';
        } else {
          atcBtn.setAttribute('disabled', '');
          atcText.textContent = 'Sold out';
          if (stickyBtnEl) stickyBtnEl.setAttribute('disabled', '');
          if (stickyBtnText) stickyBtnText.textContent = 'Sold out';
        }
      }

      if (stockLine && oosLine) {
        if (v.available) {
          stockLine.removeAttribute('hidden');
          oosLine.setAttribute('hidden', '');
        } else {
          stockLine.setAttribute('hidden', '');
          oosLine.removeAttribute('hidden');
        }
      }

      if (stickyPrice) {
        const src = currentMode === 'subscribe' ? subPriceEl : oneTimePriceEl;
        if (src) stickyPrice.textContent = src.textContent.trim();
      }
    }

    function setPurchaseMode(mode) {
      currentMode = mode;
      purchaseOptions.forEach(function (opt) {
        opt.classList.toggle('is-selected', opt.getAttribute('data-purchase-option') === mode);
      });
      purchaseInputs.forEach(function (inp) {
        inp.checked = inp.value === mode;
      });

      if (sellingPlanEl) {
        if (mode === 'subscribe') {
          if (sellingPlanEl.tagName !== 'SELECT') sellingPlanEl.value = sellingPlanValue;
          sellingPlanEl.disabled = false;
        } else {
          sellingPlanEl.disabled = true;
        }
      }

      if (stickyPrice) {
        const src = mode === 'subscribe' ? subPriceEl : oneTimePriceEl;
        if (src) stickyPrice.textContent = src.textContent.trim();
      }
    }

    purchaseOptions.forEach(function (opt) {
      opt.addEventListener('click', function (e) {
        if (e.target.tagName === 'SELECT' || e.target.tagName === 'OPTION') return;
        setPurchaseMode(opt.getAttribute('data-purchase-option'));
      });
    });

    optionInputs.forEach(function (inp) {
      inp.addEventListener('change', updateVariant);
    });

    /* ---------- Sticky mobile ATC reveal ---------- */
    const sticky = section.querySelector('[data-sticky-atc]');
    const atc = section.querySelector('[data-atc]');
    const stickyBtn = section.querySelector('[data-sticky-btn]');

    if (sticky && atc && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', show);
          sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        });
      }, { rootMargin: '0px 0px -20% 0px', threshold: 0 });
      io.observe(atc);
    }

    if (stickyBtn && atc) {
      stickyBtn.addEventListener('click', function () {
        if (stickyBtn.hasAttribute('disabled')) return;
        atc.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(function () { atc.click(); }, 400);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quiz-funnel"]) return;
  try {
    
  (function () {
    const container = document.querySelector('[data-quiz-funnel]');
    if (!container) return;

    const configEl = document.querySelector('[data-quiz-config]');
    const productsEl = document.querySelector('[data-quiz-products]');
    let config = {}, productsMap = {};
    try { config = JSON.parse(configEl.textContent); } catch (e) {}
    try { productsMap = JSON.parse(productsEl.textContent); } catch (e) {}

    const STORAGE_KEY = 'yuve_quiz_state';
    const STORAGE_TTL_MS = 7 * 24 * 60 * 60 * 1000;
    const STEPS_WITH_PROGRESS = ['q1', 'q2', 'q3', 'q4', 'q5', 'gate'];
    const QUESTION_STEPS = ['q1', 'q2', 'q3', 'q4', 'q5'];

    // Curated pools, ordered by recommendation strength. Availability is
    // already filtered at the Liquid layer - productsMap only contains in-stock.
    const POOLS = {
      digestion: ['vegan-daily-cleanse','probiotic-gummies','prebiotic-fiber-gummies','dgl-licorice-chewables','bromelain-500mg','lactase-9000fcc','dgl-licorice'],
      immunity: ['vegan-zinc-supplement','l-lysine','probiotic-gummies','folic-acid-gummies','vegan-b12'],
      energy: ['sea-kelp-iodine-vitamins','vegan-b12','whole-food-iron','probiotic-gummies','vegan-daily-cleanse','folic-acid-gummies'],
      daily: ['probiotic-gummies','folic-acid-gummies','vegan-b12','whole-food-iron','sea-kelp-iodine-vitamins','vegan-daily-cleanse','eye-health-vitamins','l-lysine']
    };

    const Q2_OPTIONS = {
      digestion: [
        { value: 'after-meals', label: 'After meals' },
        { value: 'morning', label: 'In the morning' },
        { value: 'allday', label: 'All day, on and off' },
        { value: 'how', label: 'More about how than when' }
      ],
      immunity: [
        { value: 'stress', label: 'Travel or stressful weeks' },
        { value: 'seasons', label: 'Seasonal changes' },
        { value: 'catcheverything', label: 'I catch everything that goes around' },
        { value: 'proactive', label: 'Just want to stay ahead of it' }
      ],
      energy: [
        { value: 'afternoon', label: 'Mid-afternoon slump' },
        { value: 'mornings', label: 'Mornings are rough' },
        { value: 'fog', label: 'Mental fog more than physical' },
        { value: 'workouts', label: 'I push hard through workouts' }
      ],
      daily: [
        { value: 'restricted', label: 'My diet is restricted (vegan / plant-based)' },
        { value: 'gaps', label: 'I eat well but want to cover gaps' },
        { value: 'new', label: "I'm new to supplements" },
        { value: 'steady', label: 'Nothing specific, just steady support' }
      ]
    };

    const GOAL_LABELS = { digestion: 'digestion', immunity: 'immunity', energy: 'energy', daily: 'daily foundations' };
    const AMBITION_LABELS = { one: 'starting with one thing', pair: 'a morning pair', full: 'a full routine' };
    const CTX_LABELS = {
      'after-meals': 'after-meal discomfort',
      'morning': 'morning regularity',
      'allday': 'everyday digestion',
      'how': 'how your digestion feels',
      'stress': 'stress-triggered susceptibility',
      'seasons': 'seasonal transitions',
      'catcheverything': 'frequent bugs',
      'proactive': 'proactive defense',
      'afternoon': 'the mid-afternoon slump',
      'mornings': 'rough mornings',
      'fog': 'mental fog',
      'workouts': 'training recovery',
      'restricted': 'a restricted diet',
      'gaps': 'covering diet gaps',
      'new': 'a gentle start',
      'steady': 'steady daily support'
    };

    // ---------- State ----------
    function loadState() {
      try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        if (!parsed || !parsed.timestamp) return null;
        if (Date.now() - parsed.timestamp > STORAGE_TTL_MS) {
          localStorage.removeItem(STORAGE_KEY);
          return null;
        }
        return parsed;
      } catch (e) { return null; }
    }

    function saveState() {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify({
          step: state.step,
          answers: state.answers,
          timestamp: Date.now()
        }));
      } catch (e) {}
    }

    function clearState() {
      try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
    }

    let state = loadState() || { step: 'intro', answers: {} };

    // ---------- Tracking ----------
    function trackGA(event, params) {
      try {
        if (typeof window.gtag === 'function') {
          window.gtag('event', event, params || {});
        } else if (window.dataLayer && typeof window.dataLayer.push === 'function') {
          window.dataLayer.push(Object.assign({ event: event }, params || {}));
        }
      } catch (e) {}
    }

    function trackKlaviyo(event, properties) {
      try {
        if (window._learnq && typeof window._learnq.push === 'function') {
          window._learnq.push(['track', event, properties || {}]);
        }
      } catch (e) {}
    }

    function identifyKlaviyo(email, firstName, extraProps) {
      try {
        if (window._learnq && typeof window._learnq.push === 'function') {
          const payload = { '$email': email };
          if (firstName) payload['$first_name'] = firstName;
          Object.assign(payload, extraProps || {});
          window._learnq.push(['identify', payload]);
        }
      } catch (e) {}
    }

    // ---------- Navigation ----------
    const stepEls = {};
    container.querySelectorAll('[data-step]').forEach(el => {
      stepEls[el.getAttribute('data-step')] = el;
    });

    const head = container.querySelector('[data-quiz-head]');
    const progressBar = container.querySelector('[data-quiz-progress-bar]');
    const stepLabelEl = container.querySelector('[data-quiz-step-label]');

    function updateProgress() {
      const showHead = STEPS_WITH_PROGRESS.indexOf(state.step) >= 0;
      head.hidden = !showHead;
      if (!showHead) return;
      const qIdx = QUESTION_STEPS.indexOf(state.step);
      const total = QUESTION_STEPS.length;
      if (qIdx >= 0) {
        progressBar.style.width = ((qIdx + 1) / total * 100) + '%';
        stepLabelEl.textContent = 'Question ' + (qIdx + 1) + ' of ' + total;
      } else if (state.step === 'gate') {
        progressBar.style.width = '100%';
        stepLabelEl.textContent = 'Almost there';
      }
    }

    function renderStep(step) {
      Object.keys(stepEls).forEach(k => { stepEls[k].hidden = (k !== step); });
      state.step = step;
      updateProgress();
      saveState();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    function nextStepAfter(step) {
      const order = ['intro', 'q1', 'q2', 'q3', 'q4', 'q5', 'gate', 'results'];
      const i = order.indexOf(step);
      return i >= 0 && i < order.length - 1 ? order[i + 1] : 'results';
    }

    function prevStepBefore(step) {
      const order = ['intro', 'q1', 'q2', 'q3', 'q4', 'q5', 'gate', 'results'];
      const i = order.indexOf(step);
      return i > 0 ? order[i - 1] : 'intro';
    }

    // ---------- Q2 dynamic rendering ----------
    function renderQ2Options() {
      const host = container.querySelector('[data-quiz-q2-options]');
      host.innerHTML = '';
      const opts = Q2_OPTIONS[state.answers.q1] || [];
      opts.forEach(opt => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'quiz-funnel__option';
        btn.setAttribute('data-answer', opt.value);
        btn.innerHTML = '<span class="quiz-funnel__option-label">' + opt.label + '</span>';
        btn.addEventListener('click', () => handleAnswer('q2', opt.value));
        host.appendChild(btn);
      });
    }

    // ---------- Answer handlers ----------
    function handleAnswer(questionKey, value) {
      state.answers[questionKey] = value;
      trackGA('quiz_question_answered', { step: questionKey, answer: value });
      trackKlaviyo('Answered Quiz Question', { step: questionKey, answer: value });
      saveState();

      if (questionKey === 'q1') {
        renderQ2Options();
        renderStep('q2');
      } else {
        const next = nextStepAfter(questionKey);
        if (next === 'gate') {
          trackGA('quiz_email_gate_viewed');
        } else if (next === 'results') {
          renderResults();
          trackGA('quiz_completed', flattenAnswers());
        }
        renderStep(next);
      }
    }

    function flattenAnswers() {
      return {
        quiz_goal: state.answers.q1 || '',
        quiz_context: state.answers.q2 || '',
        quiz_format: state.answers.q3 || '',
        quiz_ambition: state.answers.q4 || '',
        quiz_diet: state.answers.q5 || ''
      };
    }

    // ---------- Recommendation engine ----------
    function computeRecommendation(answers) {
      const pool = POOLS[answers.q1] || POOLS.daily;
      let candidates = pool
        .map(h => productsMap[h])
        .filter(p => !!p);

      if (candidates.length < 3) {
        const dailyExtras = POOLS.daily
          .map(h => productsMap[h])
          .filter(p => p && !candidates.some(c => c.handle === p.handle));
        candidates = candidates.concat(dailyExtras);
      }

      if (answers.q3 && answers.q3 !== 'any') {
        candidates.sort((a, b) => {
          const aMatch = a.format === answers.q3 ? 1 : 0;
          const bMatch = b.format === answers.q3 ? 1 : 0;
          return bMatch - aMatch;
        });
      }

      return candidates.slice(0, 3);
    }

    // ---------- Results rendering ----------
    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function stars(rating) {
      const full = Math.floor(rating);
      let out = '';
      for (let i = 1; i <= 5; i++) out += (i <= full) ? '★' : '☆';
      return out;
    }

    function whyLine(product, answers, position) {
      const ctx = CTX_LABELS[answers.q2] || GOAL_LABELS[answers.q1];
      if (position === 0) {
        return 'Leads your routine for <b>' + ctx + '</b>.';
      } else if (position === 1) {
        return 'Pairs with the lead - widens the base of support.';
      } else {
        return 'Rounds out the stack to unlock the bundle discount.';
      }
    }

    function renderResultCard(product, position, ambition) {
      const card = document.createElement('article');
      const isSecondary = (ambition === 'one' && position > 0) || (ambition === 'pair' && position > 1);
      card.className = 'quiz-result' + (position === 0 ? ' quiz-result--hero' : '') + (isSecondary ? ' quiz-result--secondary' : '');
      card.dataset.handle = product.handle;

      const media = document.createElement('a');
      media.href = product.url;
      media.className = 'quiz-result__media';
      if (product.image) {
        const img = document.createElement('img');
        img.src = product.image;
        img.alt = product.title;
        img.loading = 'lazy';
        media.appendChild(img);
      }

      const body = document.createElement('div');
      body.className = 'quiz-result__body';

      const title = document.createElement('h3');
      title.className = 'quiz-result__title';
      const titleLink = document.createElement('a');
      titleLink.href = product.url;
      titleLink.textContent = product.title;
      titleLink.style.color = 'inherit';
      titleLink.style.textDecoration = 'none';
      title.appendChild(titleLink);
      body.appendChild(title);

      if (!isSecondary && product.benefit) {
        const benefit = document.createElement('p');
        benefit.className = 'quiz-result__benefit';
        benefit.textContent = product.benefit;
        body.appendChild(benefit);
      }

      if (!isSecondary && product.rating > 0) {
        const rating = document.createElement('p');
        rating.className = 'quiz-result__rating';
        const starsEl = document.createElement('span');
        starsEl.className = 'quiz-result__stars';
        starsEl.setAttribute('aria-hidden', 'true');
        starsEl.textContent = stars(product.rating);
        rating.appendChild(starsEl);
        const ratingText = document.createElement('span');
        ratingText.textContent = product.rating.toFixed(1) + (product.ratingCount >= 100 ? ' · ' + product.ratingCount + ' reviews' : '');
        rating.appendChild(ratingText);
        body.appendChild(rating);
      }

      const why = document.createElement('p');
      why.className = 'quiz-result__why';
      why.innerHTML = '<b>Why this fits:</b> ' + whyLine(product, state.answers, position);
      body.appendChild(why);

      const price = document.createElement('div');
      price.className = 'quiz-result__price';
      if (product.subPrice !== null && product.subPrice !== undefined) {
        const sub = document.createElement('span');
        sub.className = 'quiz-result__price-sub';
        sub.textContent = formatMoney(product.subPrice) + '/mo';
        price.appendChild(sub);
        const one = document.createElement('span');
        one.className = 'quiz-result__price-one';
        one.textContent = formatMoney(product.price) + ' one-time';
        price.appendChild(one);
      } else {
        const sub = document.createElement('span');
        sub.className = 'quiz-result__price-sub';
        sub.textContent = formatMoney(product.price);
        price.appendChild(sub);
      }
      body.appendChild(price);

      const actions = document.createElement('div');
      actions.className = 'quiz-result__actions';

      const addBtn = document.createElement('button');
      addBtn.type = 'button';
      addBtn.className = 'quiz-result__add';
      addBtn.textContent = 'Add to cart';
      addBtn.addEventListener('click', () => addOne(product, addBtn));
      actions.appendChild(addBtn);

      const viewBtn = document.createElement('a');
      viewBtn.href = product.url;
      viewBtn.className = 'quiz-result__view';
      viewBtn.textContent = 'See product';
      actions.appendChild(viewBtn);

      body.appendChild(actions);

      card.appendChild(media);
      card.appendChild(body);
      return card;
    }

    function renderResults() {
      const recs = computeRecommendation(state.answers);
      const grid = container.querySelector('[data-quiz-results-grid]');
      grid.innerHTML = '';
      recs.forEach((p, i) => grid.appendChild(renderResultCard(p, i, state.answers.q4)));

      // Subtitle
      const ctxPhrase = CTX_LABELS[state.answers.q2] ? ' and ' + CTX_LABELS[state.answers.q2] : '';
      const goalPhrase = GOAL_LABELS[state.answers.q1] || 'your goal';
      const ambitionPhrase = AMBITION_LABELS[state.answers.q4] || 'your routine';
      const subtitleEl = container.querySelector('[data-quiz-results-subtitle]');
      subtitleEl.textContent = 'Based on your focus on ' + goalPhrase + ctxPhrase + ', we\'d start with ' + ambitionPhrase + '.';

      // Personalized title if we have a first name
      if (state.answers.firstName) {
        const titleEl = container.querySelector('[data-quiz-results-title]');
        titleEl.textContent = state.answers.firstName + "'s Yuve routine.";
      }

      // Bottom CTA
      const ctaBtn = container.querySelector('[data-quiz-results-cta]');
      const ctaHint = container.querySelector('[data-quiz-results-cta-hint]');
      const ambition = state.answers.q4;
      const n = recs.length;
      if (ambition === 'full' && n >= 3) {
        ctaBtn.textContent = 'Add all ' + n + ' to routine - save 20%';
        ctaHint.textContent = 'The 20% bundle discount applies automatically at checkout.';
      } else if (ambition === 'pair') {
        ctaBtn.textContent = 'Add the pair';
        ctaHint.textContent = 'Or add all ' + n + ' and unlock the 20% bundle discount.';
      } else {
        ctaBtn.textContent = 'Add the lead product';
        ctaHint.textContent = 'Or add all ' + n + ' and unlock the 20% bundle discount at checkout.';
      }
      ctaBtn.onclick = () => addRoutine(recs, ambition, ctaBtn);

      // Why panel
      const why = container.querySelector('[data-quiz-why]');
      why.innerHTML = '';
      const p1 = document.createElement('p');
      p1.innerHTML = 'You told us: focused on <b>' + goalPhrase + '</b>' + (state.answers.q2 ? ', triggered by <b>' + (CTX_LABELS[state.answers.q2] || state.answers.q2) + '</b>' : '') + (state.answers.q3 && state.answers.q3 !== 'any' ? ', prefers <b>' + state.answers.q3 + '</b>' : '') + (state.answers.q5 && state.answers.q5 !== 'any' ? ', diet: <b>' + state.answers.q5 + '</b>' : '') + '.';
      why.appendChild(p1);
      const p2 = document.createElement('p');
      p2.textContent = "We started from the products that best match that goal, then pushed your preferred format to the top of the list. Every recommendation is in stock right now; none is a partial dose. If something doesn't land, use 'Reset quiz' below.";
      why.appendChild(p2);
    }

    function addOne(product, btn) {
      const originalText = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding…';
      const item = { id: product.variantId, quantity: 1 };
      if (product.sellingPlanId) item.selling_plan = product.sellingPlanId;

      trackGA('quiz_result_atc', { handle: product.handle, mode: 'single' });
      trackKlaviyo('Quiz Result Added to Cart', { handle: product.handle, mode: 'single' });

      const addPromise = (window.YuveCart && typeof window.YuveCart.addItems === 'function')
        ? window.YuveCart.addItems([item])
        : fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [item] })
          });

      Promise.resolve(addPromise).then(() => {
        btn.textContent = 'Added ✓';
        setTimeout(() => { btn.disabled = false; btn.textContent = originalText; }, 1800);
      }).catch(() => {
        btn.disabled = false;
        btn.textContent = originalText;
      });
    }

    function addRoutine(recs, ambition, btn) {
      const originalText = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding…';

      // Based on Q4, choose how many to add: one = 1, pair = 2, full = all
      let slice;
      if (ambition === 'one') slice = recs.slice(0, 1);
      else if (ambition === 'pair') slice = recs.slice(0, 2);
      else slice = recs;

      const items = slice.map(p => {
        const item = { id: p.variantId, quantity: 1 };
        if (p.sellingPlanId) item.selling_plan = p.sellingPlanId;
        return item;
      });

      trackGA('quiz_result_atc', { mode: ambition || 'full', count: items.length });
      trackKlaviyo('Quiz Routine Added to Cart', { mode: ambition || 'full', count: items.length, handles: slice.map(p => p.handle).join(',') });

      const addPromise = (window.YuveCart && typeof window.YuveCart.addItems === 'function')
        ? window.YuveCart.addItems(items)
        : fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: items })
          });

      Promise.resolve(addPromise).then(() => {
        btn.textContent = 'Added ✓';
        setTimeout(() => { btn.disabled = false; btn.textContent = originalText; }, 2200);
      }).catch(() => {
        btn.disabled = false;
        btn.textContent = originalText;
      });
    }

    // ---------- Email gate ----------
    async function submitEmailGate(email, firstName) {
      const publicKey = config.klaviyoKey;
      const listId = config.klaviyoListId;
      if (!publicKey || !listId) throw new Error('Email subscription is not configured.');

      const properties = Object.assign(
        { signup_source: 'Quiz' },
        flattenAnswers()
      );
      if (firstName) properties.first_name = firstName;

      const body = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Quiz',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  properties: properties
                }
              }
            }
          },
          relationships: {
            list: { data: { type: 'list', id: listId } }
          }
        }
      };

      const url = 'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(publicKey);
      const res = await fetch(url, {
        method: 'POST',
        headers: {
          'accept': 'application/vnd.api+json',
          'content-type': 'application/vnd.api+json',
          'revision': '2024-10-15'
        },
        body: JSON.stringify(body)
      });

      if (res.status === 202 || (res.status >= 200 && res.status < 300)) return true;
      let msg = 'We could not save your email. You can still see your results.';
      try {
        const data = await res.json();
        if (data && data.errors && data.errors[0] && data.errors[0].detail) msg = data.errors[0].detail;
      } catch (e) {}
      throw new Error(msg);
    }

    // ---------- Event wiring ----------
    container.querySelector('[data-quiz-start]').addEventListener('click', () => {
      trackGA('quiz_started');
      trackKlaviyo('Started Quiz');
      renderStep('q1');
    });

    container.querySelectorAll('[data-step="q1"] .quiz-funnel__card').forEach(btn => {
      btn.addEventListener('click', () => handleAnswer('q1', btn.getAttribute('data-answer')));
    });

    container.querySelectorAll('[data-step="q3"] .quiz-funnel__option, [data-step="q4"] .quiz-funnel__option, [data-step="q5"] .quiz-funnel__option').forEach(btn => {
      btn.addEventListener('click', () => {
        const step = btn.closest('[data-step]').getAttribute('data-step');
        handleAnswer(step, btn.getAttribute('data-answer'));
      });
    });

    container.querySelectorAll('[data-quiz-back]').forEach(btn => {
      btn.addEventListener('click', () => renderStep(prevStepBefore(state.step)));
    });

    const gateForm = container.querySelector('[data-quiz-gate-form]');
    const gateMessage = container.querySelector('[data-quiz-form-message]');
    gateForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const emailInput = gateForm.querySelector('input[type="email"]');
      const firstNameInput = gateForm.querySelector('input[name="first_name"]');
      const submitBtn = gateForm.querySelector('button[type="submit"]');
      const email = (emailInput.value || '').trim();
      const firstName = (firstNameInput.value || '').trim();

      if (!email) {
        gateMessage.textContent = 'Please enter your email.';
        gateMessage.dataset.state = 'error';
        gateMessage.hidden = false;
        return;
      }

      gateMessage.hidden = true;
      submitBtn.disabled = true;
      const originalLabel = submitBtn.textContent;
      submitBtn.textContent = 'Sending…';

      try {
        await submitEmailGate(email, firstName);
        state.answers.email = email;
        if (firstName) state.answers.firstName = firstName;
        saveState();
        identifyKlaviyo(email, firstName, flattenAnswers());
        trackGA('quiz_email_submitted');
        trackKlaviyo('Completed Quiz', Object.assign({ email_captured: true }, flattenAnswers()));
        renderResults();
        renderStep('results');
      } catch (err) {
        gateMessage.textContent = err.message || 'Could not save your email.';
        gateMessage.dataset.state = 'error';
        gateMessage.hidden = false;
      } finally {
        submitBtn.disabled = false;
        submitBtn.textContent = originalLabel;
      }
    });

    container.querySelector('[data-quiz-skip]').addEventListener('click', () => {
      trackGA('quiz_email_skipped');
      trackKlaviyo('Completed Quiz', Object.assign({ email_captured: false }, flattenAnswers()));
      renderResults();
      renderStep('results');
    });

    container.querySelector('[data-quiz-reset]').addEventListener('click', () => {
      trackGA('quiz_reset', { last_step: state.step });
      clearState();
      state = { step: 'intro', answers: {} };
      renderStep('intro');
    });

    // ---------- Initial render ----------
    // If resuming a Q2, re-populate conditional options.
    if (state.step === 'q2' && state.answers.q1) renderQ2Options();
    // If resuming at results, re-render recommendations.
    if (state.step === 'results') renderResults();
    renderStep(state.step);
  })();

  } catch(e) { console.error(e); }
})();
})();
